const EDGE = 40;
const MAX_STEP = 30;

export function edgeStep(pos: number, start: number, end: number): number {
  if (pos < start + EDGE) return -Math.min(MAX_STEP, Math.ceil((start + EDGE - pos) / 2));
  if (pos > end - EDGE) return Math.min(MAX_STEP, Math.ceil((pos - end + EDGE) / 2));
  return 0;
}

interface PointerEventLike {
  button: number;
  clientX: number;
  clientY: number;
}

export function autoScrollWhileDragging(scroller: HTMLElement | null, event: PointerEventLike): () => void {
  if (!scroller || event.button !== 0) return () => {};
  let pointer = { x: event.clientX, y: event.clientY };
  let lastTarget: Element | null = null;
  let frame = 0;

  const tick = () => {
    const box = scroller.getBoundingClientRect();
    const top = box.top + scroller.clientTop;
    const left = box.left + scroller.clientLeft;
    const bottom = top + scroller.clientHeight;
    const right = left + scroller.clientWidth;
    const dx = edgeStep(pointer.x, left, right);
    const dy = edgeStep(pointer.y, top, bottom);
    if (dx || dy) {
      scroller.scrollBy(dx, dy);
      const x = Math.min(Math.max(pointer.x, left + 1), right - 1);
      const y = Math.min(Math.max(pointer.y, top + 1), bottom - 1);
      const target = document.elementFromPoint(x, y);
      if (target && target !== lastTarget && scroller.contains(target)) {
        lastTarget = target;
        target.dispatchEvent(new MouseEvent('mouseover', { bubbles: true }));
      }
    }
    frame = requestAnimationFrame(tick);
  };

  const onMove = (e: globalThis.MouseEvent) => {
    pointer = { x: e.clientX, y: e.clientY };
    lastTarget = null;
  };
  const stop = () => {
    cancelAnimationFrame(frame);
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', stop);
  };

  document.addEventListener('mousemove', onMove);
  document.addEventListener('mouseup', stop);
  frame = requestAnimationFrame(tick);
  return stop;
}
